import { Navigate, useParams } from 'react-router-dom';
import {
  isMonthValid,
  isYearValid,
} from '@/domain/termine/shared/utils/dateValidations';
import { NewDesignBanner } from '@/components/Banner/NewDesignBanner';
import { buildLink } from '@/utils/linkBuilder';
import { t } from 'i18next';
import { Helmet } from 'react-helmet-async';
import { cn } from '@/lib/utils';
import {
  TermineDesktopContent,
  TermineMobileContent,
} from '@/domain/termine/pages';
import { CalendarProvider } from '@/domain/termine/features/Calendar/shared/CalendarProvider';

export function Uebersicht() {
  const { year, month } = useParams();

  const defaultYear = new Date().getFullYear().toString();
  const defaultMonth = (new Date().getMonth() + 1).toString();

  // eslint-disable-next-line complexity
  function getRedirect() {
    if (!year || !month) {
      return `/termine/uebersicht/${defaultYear}/${defaultMonth}`;
    }
    if (month.startsWith('0') && month.length > 1) {
      return `/termine/uebersicht/${year}/${parseInt(month, 10)}`;
    }
    if (!isYearValid(year) || !isMonthValid(month)) {
      return `/termine/uebersicht/${defaultYear}/${defaultMonth}`;
    }
    return null;
  }

  const redirectTo = getRedirect();
  if (redirectTo) {
    return <Navigate to={redirectTo} replace />;
  }

  return (
    <>
      <NewDesignBanner link={buildLink('termine')} />
      <div>
        <Helmet>
          <title>{t('domain.termine.title')}</title>
        </Helmet>
        <CalendarProvider>
          <div
            className={cn(
              'hidden md:block md:flex-col md:gap-8 md:p-4 md:w-screen',
              'lg:p-10 2xl:max-w-screen-2xl 2xl:mx-auto',
            )}>
            <TermineDesktopContent />
          </div>
          <div className="block md:hidden">
            <TermineMobileContent />
          </div>
        </CalendarProvider>
      </div>
    </>
  );
}
